import { Alert, SxProps } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { ReactNode } from 'react';

interface ITreatmentAlert {
  children: ReactNode;
  isBackgroundColorActive?: boolean;
  alertSx?: SxProps;
}

export const TreatmentAlert = ({
  children,
  alertSx,
  isBackgroundColorActive = true,
}: ITreatmentAlert) => {
  const isDesktop = useIsDesktop();

  return (
    <Alert
      severity='info'
      sx={{
        gap: '8px',
        '&.MuiPaper-root': {
          backgroundColor: isBackgroundColorActive
            ? 'primary.shade_100'
            : 'transparent',
          padding: isBackgroundColorActive ? '12px' : '0',
        },
        '&.MuiAlert-message': {
          display: 'flex',
          flexDirection: isDesktop ? 'row' : 'column',
          flexWrap: 'wrap',
        },
        '&.MuiAlert-icon': {
          padding: 0,
        },
        ...alertSx,
      }}
      icon={<></>}
    >
      {children}
    </Alert>
  );
};
